var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeploy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 56V49.09C12.4982 40.5488 15.0243 32.1981 19.76 25.09L20.5 24",
    stroke: "#757575",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 24L45.24 25.11C49.9757 32.2181 52.5018 40.5688 52.5 49.11V56",
    stroke: "#757575",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 44L41.76 44.91C35.7503 46.9203 29.2497 46.9203 23.24 44.91L20.5 44V20C20.5 16.8174 21.7643 13.7652 24.0147 11.5147C26.2652 9.26428 29.3174 8 32.5 8C35.6826 8 38.7348 9.26428 40.9853 11.5147C43.2357 13.7652 44.5 16.8174 44.5 20V44Z",
    stroke: "#757575",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 36V24",
    stroke: "#757575",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploy);
export default __webpack_public_path__ + "static/media/deploy.74cd54270f0a0b51353234ddc06c33c2.svg";
export { ForwardRef as ReactComponent };